import PropTypes from 'prop-types';

export const MapPosition = PropTypes.shape({
  lng: PropTypes.number,
  lat: PropTypes.number,
});

export const ElementPosition = PropTypes.oneOf(['Top', 'Right', 'Bottom', 'Left']);

export default { MapPosition, ElementPosition };
